import { isCCApp, nativeShare } from '../../../utils/share'

function share(link) {
  const [title, text, url] = link.split('#').slice(1)

  if (nativeShare) {
    nativeShare({
      title: decodeURIComponent(title),
      text: decodeURIComponent(text) + ' ' + decodeURIComponent(url),
      url: ''
    })
  }
}

function createShareUrl({ title, text, url }) {
  return `#${title}#${text}#${url}`
}

export default {
  id: 'share',
  title: 'Share',
  share,
  createShareUrl,
  showLegalInfo: false,
  available: !!nativeShare && isCCApp // We just enable it for the cc app for now
}
